import { styled, breakpointUp } from '@moonpig/launchpad-utils'
import React from 'react'
import { Orientation } from '../utils/types'

const StyledImageContainer = styled.div`
  &::before {
    content: '';
    display: block;
    width: 70%;
    background: linear-gradient(
      94deg,
      rgba(234, 234, 234, 1) 18.79%,
      rgba(235, 235, 235, 1) 58.01%,
      rgba(255, 255, 255, 1) 94.33%
    );
    position: absolute;
    transform: skew(0, -6deg) translateZ(0);
  }
  position: relative;
  z-index: 2;
`

const StyledPortraitImageContainer = styled(StyledImageContainer)`
  transform: skew(0, 2deg) translate3d(-3px, -8px, 0);
  &::before {
    height: 75px;
    left: 13px;
    top: -3%;
    ${breakpointUp('sm')} {
      left: 17px;
    }
    ${breakpointUp('md')} {
      left: 5%;
    }
  }
  &::after {
    content: '';
    position: absolute;
    pointer-events: none;
    right: 0%;
    bottom: 5%;
    width: 10%;
    height: 4%;
    z-index: -1;
    background: linear-gradient(90deg,
      rgba(0, 0, 0, 0.2) 50%,
      rgba(0, 0, 0, 0.08) 80%,
      rgba(0, 0, 0, 0) 100%
    );
    filter: blur(6px);
    transform: skewX(-55deg) scaleX(2.4) scaleY(1.9);
    opacity: 0.9;
  }
`

const StyledSquareImageContainer = styled(StyledImageContainer)`
  transform: skew(0, 2deg) translate3d(-3px, -8px, 0);
  &::before {
    height: 50px;
    left: 13px;
    top: -3%;
    ${breakpointUp('sm')} {
      left: 17px;
    }
    ${breakpointUp('md')} {
      left: 5%;
    }
  }
`

const StyledLandscapeImageContainer = styled(StyledImageContainer)`
  transform: skew(-2deg, 0) translate3d(-8%, 1px, 0);
  &::before {
    height: 77%;
    right: -3%;
    top: 0;
    transform: skew(6deg, 0) translateZ(0);
    background: linear-gradient(
      180deg,
      rgba(234, 234, 234, 1) 18.79%,
      rgba(235, 235, 235, 1) 58.01%,
      rgba(255, 255, 255, 1) 94.33%
    );
  }
  &::after {
    content: '';
    position: absolute;
    pointer-events: none;
    right: 0%;
    bottom: 5%;
    width: 10%;
    height: 4%;
    z-index: -1;
    background: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.2) 50%,
      rgba(0, 0, 0, 0.08) 80%,
      rgba(0, 0, 0, 0) 100%
    );
    filter: blur(6px);
    transform: skewX(-55deg) scaleX(2.4) scaleY(1.9);
    opacity: 0.9;
  }
`

export const CardImageOrientationWrapper: React.FC<{
  orientation: Orientation
  children: React.JSX.Element
}> = ({ orientation, children }) => {
  switch (orientation) {
    case Orientation.Landscape:
      return (
        <StyledLandscapeImageContainer>
          {children}
        </StyledLandscapeImageContainer>
      )
    case Orientation.Square:
      return <StyledSquareImageContainer>{children}</StyledSquareImageContainer>
    default:
      return (
        <StyledPortraitImageContainer>{children}</StyledPortraitImageContainer>
      )
  }
}
